// eslint-disable-next-line import/no-anonymous-default-export
export default {
  formId: "PostDocUploadForm",
  formField: {
    statementReportGuideline: {
      name: "statementReportGuideline",
      label: "Have you read entire statement in report guideline? *",
      requiredErrorMsg: "Report guideline is required"
    },
    sendingFellowshipReport: {
      name: "sendingFellowshipReport",
      label: "Sending the fellowship report for: *",
      requiredErrorMsg: "Sending the fellowship report is required"
    },
    mainResearchArea: {
      name: "mainResearchArea",
      label: "Your Main Research Area: *",
      requiredErrorMsg: "Main Research Area is required"
    },
    researchTitleEnglish: {
      name: "researchTitleEnglish",
      label: "Your Research Title (In English): *",
      requiredErrorMsg: "Research Title is required"
    },
    progressCommencementFellowship: {
      name: "progressCommencementFellowship",
      label:
        "Assess your percent (%) successful of working progress from the commencement of this fellowship:",
      requiredErrorMsg: "Percent successful is required"
    },
    presentProgressResearchProject: {
      name: "presentProgressResearchProject",
      label: "Please select your present progress of the research project:",
      requiredErrorMsg: "Research project is required"
    },

    //secAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
    whatYourStatus: {
      name: "whatYourStatus",
      label: "What is your status? *",
      requiredErrorMsg: "Status is required"
    },
    AssessMainProgressAchieved: {
      name: "AssessMainProgressAchieved",
      label:
        "Assess your main progress achieved (%o present successful) since commencement of this fellowship until preparing the manuscript for publication: *",
      requiredErrorMsg: "Assess your main progress is required"
    },
    ListJournalSubject: {
      name: "ListJournalSubject",
      label:
        "List of journal and Subject Area which you expect to be published; (for example: journal: Energies / Subject Area: Electrical and Electronic Engineering) *",
      requiredErrorMsg: "List of journal and Subject is required"
    },
    researchPlanRelevantIndicates: {
      name: "researchPlanRelevantIndicates",
      label:
        "Please attach your research plan or relevant document which indicates present obtained result(s):*",
      requiredErrorMsg: "Research plan or Relevant is required",
      file: {}
    },
    additionalInformNote: {
      name: "additionalInformNote",
      label: "Additional inform/Note",
      requiredErrorMsg: "Additional inform/Note is required"
    },
    additionalDocument: {
      name: "additionalDocument",
      label: "Additional document",
      requiredErrorMsg: "Additional document is required",
      file: {}
    },
    //secAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA

    //secBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
    submissionStatus: {
      name: "submissionStatus",
      label: "What is your submission status?*",
      requiredErrorMsg: "Submission status is required"
    },
    submitDate: {
      name: "submitDate",
      label: "Submit date:*",
      requiredErrorMsg: "Submit date is required"
    },
    receivedDate: {
      name: "receivedDate",
      label: "Received date:",
      requiredErrorMsg: "Received date is required"
    },
    revisedDate: {
      name: "revisedDate",
      label: "Revised date:",
      requiredErrorMsg: "Revised date is required"
    },
    articleTitle: {
      name: "articleTitle",
      label: "Article Title",
      requiredErrorMsg: "Article Title is required"
    },
    manuscriptID: {
      name: "manuscriptID",
      label: "Your manuscript ID: *",
      requiredErrorMsg: "Manuscript ID is required"
    },
    typeManuscript: {
      name: "typeManuscript",
      label: "Type of Manuscript: *",
      requiredErrorMsg: "Type of Manuscript is required"
    },
    journal: {
      name: "journal",
      label: "Journal: *",
      requiredErrorMsg: "Journal is required"
    },
    subjectAreaCategory: {
      name: "subjectAreaCategory",
      label: "Subject area and category *",
      requiredErrorMsg: "Subject area and category is required"
    },
    journalRanking: {
      name: "journalRanking",
      label: "Journal ranking: *",
      requiredErrorMsg: "Journal ranking is required"
    },
    authors: {
      name: "authors",
      label: "Authors: *",
      requiredErrorMsg: "Authors is required"
    },
    firstAuthorName: {
      name: "firstAuthorName",
      label: "First author's name *",
      requiredErrorMsg: "First author's name is required"
    },
    correspondingAuthorName: {
      name: "correspondingAuthorName",
      label: "Corresponding author's name *",
      requiredErrorMsg: "Corresponding author's name is required"
    },
    coauthorAbroadPublication: {
      name: "coauthorAbroadPublication",
      label: "Do you have a co-author from abroad in your publication? *",
      requiredErrorMsg: "co-author is required"
    },
    coauthorName: {
      name: "coauthorName",
      label: "Co-author's name (Collaborator from abroad)*",
      requiredErrorMsg: "Co-author's name is required"
    },
    coResearcherUniversityInstituteName: {
      name: "coResearcherUniversityInstituteName",
      label: "Co-researcher's university/Institute name",
      requiredErrorMsg: "Co-researcher's is required"
    },
    coResearcherUniversityInstituteRanking: {
      name: "coResearcherUniversityInstituteRanking",
      label: "Co-researcher's University/Institute ranking",
      requiredErrorMsg: "Co-researcher's is required"
    },
    supportedSecondCenturyFund: {
      name: "supportedSecondCenturyFund",
      label:
        "Did you include in the acknowledgement in the statement This research project is supported by the Second Century Fund (C2F), Chulalongkorn University.*",
      requiredErrorMsg: "Supported is required"
    },
    uploadManuscript: {
      name: "uploadManuscript",
      label: "Please upload your manuscript *",
      requiredErrorMsg: "Manuscript is required",
      file: {}
    },
    documentsShowingsSubmission: {
      name: "documentsShowingsSubmission",
      label:
        "Please attach evidence or relevant documents showing the submission: *",
      requiredErrorMsg: "Attach evidence is required",
      file: {}
    },
    attachEvidenceTier1Paper: {
      name: "attachEvidenceTier1Paper",
      label: "Please attach an evidence of Tier1 paper *",
      requiredErrorMsg: "Attach evidence is required",
      file: {}
    },
    attachEvidenceUniversityInstituteRanking: {
      name: "attachEvidenceUniversityInstituteRanking",
      label:
        "Please attach the evidence of the Co-researcher's University/Institute ranking *",
      requiredErrorMsg: "Attach evidence is required",
      file: {}
    },
    additionalInformNoteSecB: {
      name: "additionalInformNoteSecB",
      label: "Additional inform/Note",
      requiredErrorMsg: "Additional inform/Note is required"
    },
    additionalDocumentSecB: {
      name: "additionalDocumentSecB",
      label: "Additional document",
      requiredErrorMsg: "Additional document is required",
      file: {}
    },
    //secBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB

    //secCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC
    receivedDateSecC: {
      name: "receivedDateSecC",
      label: "Received date:",
      requiredErrorMsg: "Received date is required"
    },
    submitDateSecC: {
      name: "submitDateSecC",
      label: "Submit date:*",
      requiredErrorMsg: "Submit date is required"
    },
    acceptedDateSecC: {
      name: "acceptedDateSecC",
      label: "Accepted date:*",
      requiredErrorMsg: "Accepted date is required"
    },
    revisedDateSecC: {
      name: "revisedDateSecC",
      label: "Revised date:",
      requiredErrorMsg: "Revised date is required"
    },

    articleTitleSecC: {
      name: "articleTitleSecC",
      label: "Article Title",
      requiredErrorMsg: "Article Title is required"
    },
    manuscriptIDSecC: {
      name: "manuscriptIDSecC",
      label: "Your manuscript ID: *",
      requiredErrorMsg: "Manuscript ID is required"
    },
    typeManuscriptSecC: {
      name: "typeManuscriptSecC",
      label: "Type of Manuscript: *",
      requiredErrorMsg: "Type of Manuscript is required"
    },
    journalSecC: {
      name: "journalSecC",
      label: "Journal: *",
      requiredErrorMsg: "Journal is required"
    },
    subjectAreaCategorySecC: {
      name: "subjectAreaCategorySecC",
      label: "Subject area and category *",
      requiredErrorMsg: "Subject area and category is required"
    },
    journalRankingSecC: {
      name: "journalRankingSecC",
      label: "Journal ranking: *",
      requiredErrorMsg: "Journal ranking is required"
    },
    authorsSecC: {
      name: "authorsSecC",
      label: "Authors: *",
      requiredErrorMsg: "Authors is required"
    },
    firstAuthorNameSecC: {
      name: "firstAuthorNameSecC",
      label: "First author's name *",
      requiredErrorMsg: "First author's name is required"
    },
    correspondingAuthorNameSecC: {
      name: "correspondingAuthorNameSecC",
      label: "Corresponding author's name *",
      requiredErrorMsg: "Corresponding author's name is required"
    },
    coauthorAbroadPublicationSecC: {
      name: "coauthorAbroadPublicationSecC",
      label: "Do you have a co-author from abroad in your publication? *",
      requiredErrorMsg: "co-author is required"
    },
    coauthorNameSecC: {
      name: "coauthorNameSecC",
      label: "Co-author's name (Collaborator from abroad)*",
      requiredErrorMsg: "Co-author's name is required"
    },
    coResearcherUniversityInstituteNameSecC: {
      name: "coResearcherUniversityInstituteNameSecC",
      label: "Co-researcher's university/Institute name",
      requiredErrorMsg: "Co-researcher's is required"
    },
    coResearcherUniversityInstituteRankingSecC: {
      name: "coResearcherUniversityInstituteRankingSecC",
      label: "Co-researcher's University/Institute ranking",
      requiredErrorMsg: "Co-researcher's is required"
    },
    supportedSecondCenturyFundSecC: {
      name: "supportedSecondCenturyFundSecC",
      label:
        "Did you include in the acknowledgement in the statement This research project is supported by the Second Century Fund (C2F), Chulalongkorn University.*",
      requiredErrorMsg: "Supported is required"
    },
    uploadManuscriptSecC: {
      name: "uploadManuscriptSecC",
      label: "Please upload your manuscript *",
      requiredErrorMsg: "Manuscript is required",
      file: {}
    },
    documentsShowingsSubmissionSecC: {
      name: "documentsShowingsSubmissionSecC",
      label:
        "Please attach evidence or relevant documents showing the submission: *",
      requiredErrorMsg: "Attach evidence is required",
      file: {}
    },
    publicationAcceptedEvidenceSecC: {
      name: "publicationAcceptedEvidenceSecC",
      label: "Please upload your research publication or accepted evidence: *",
      requiredErrorMsg: "Attach evidence is required",
      file: {}
    },
    attachEvidenceTier1PaperSecC: {
      name: "attachEvidenceTier1PaperSecC",
      label: "Please attach an evidence of Tier1 paper *",
      requiredErrorMsg: "Attach evidence is required",
      file: {}
    },
    attachEvidenceUniversityInstituteRankingSecC: {
      name: "attachEvidenceUniversityInstituteRankingSecC",
      label:
        "Please attach the evidence of the Co-researcher's University/Institute ranking *",
      requiredErrorMsg: "Attach evidence is required",
      file: {}
    },
    additionalInformNoteSecC: {
      name: "additionalInformNoteSecC",
      label: "Additional inform/Note",
      requiredErrorMsg: "Additional inform/Note is required"
    },
    additionalDocumentSecC: {
      name: "additionalDocumentSecC",
      label: "Additional document",
      requiredErrorMsg: "Additional document is required",
      file: {}
    },
    //secCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC

    //secDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD
    receivedDateSecD: {
      name: "receivedDateSecD",
      label: "Received date:",
      requiredErrorMsg: "Received date is required"
    },
    submitDateSecD: {
      name: "submitDateSecD",
      label: "Submit date:*",
      requiredErrorMsg: "Submit date is required"
    },
    acceptedDateSecD: {
      name: "acceptedDateSecD",
      label: "Accepted date:*",
      requiredErrorMsg: "Accepted date is required"
    },
    revisedDateSecD: {
      name: "revisedDateSecD",
      label: "Revised date:",
      requiredErrorMsg: "Revised date is required"
    },
    publishedDateSecD: {
      name: "publishedDateSecD",
      label: "Published date:*",
      requiredErrorMsg: "Published date is required"
    },
    articleTitleSecD: {
      name: "articleTitleSecD",
      label: "Article Title",
      requiredErrorMsg: "Article Title is required"
    },
    manuscriptIDSecD: {
      name: "manuscriptIDSecD",
      label: "Your manuscript ID: *",
      requiredErrorMsg: "Manuscript ID is required"
    },
    typeManuscriptSecD: {
      name: "typeManuscriptSecD",
      label: "Type of Manuscript: *",
      requiredErrorMsg: "Type of Manuscript is required"
    },
    journalSecD: {
      name: "journalSecD",
      label: "Journal: *",
      requiredErrorMsg: "Journal is required"
    },
    subjectAreaCategorySecD: {
      name: "subjectAreaCategorySecD",
      label: "Subject area and category *",
      requiredErrorMsg: "Subject area and category is required"
    },
    journalRankingSecD: {
      name: "journalRankingSecD",
      label: "Journal ranking: *",
      requiredErrorMsg: "Journal ranking is required"
    },
    authorsSecD: {
      name: "authorsSecD",
      label: "Authors: *",
      requiredErrorMsg: "Authors is required"
    },
    firstAuthorNameSecD: {
      name: "firstAuthorNameSecD",
      label: "First author's name *",
      requiredErrorMsg: "First author's name is required"
    },
    correspondingAuthorNameSecD: {
      name: "correspondingAuthorNameSecD",
      label: "Corresponding author's name *",
      requiredErrorMsg: "Corresponding author's name is required"
    },
    coauthorAbroadPublicationSecD: {
      name: "coauthorAbroadPublicationSecD",
      label: "Do you have a co-author from abroad in your publication? *",
      requiredErrorMsg: "co-author is required"
    },
    coauthorNameSecD: {
      name: "coauthorNameSecD",
      label: "Co-author's name (Collaborator from abroad)*",
      requiredErrorMsg: "Co-author's name is required"
    },
    coResearcherUniversityInstituteNameSecD: {
      name: "coResearcherUniversityInstituteNameSecD",
      label: "Co-researcher's university/Institute name",
      requiredErrorMsg: "Co-researcher's is required"
    },
    coResearcherUniversityInstituteRankingSecD: {
      name: "coResearcherUniversityInstituteRankingSecD",
      label: "Co-researcher's University/Institute ranking",
      requiredErrorMsg: "Co-researcher's is required"
    },
    supportedSecondCenturyFundSecD: {
      name: "supportedSecondCenturyFundSecD",
      label:
        "Did you include in the acknowledgement in the statement This research project is supported by the Second Century Fund (C2F), Chulalongkorn University.*",
      requiredErrorMsg: "Supported is required"
    },
    uploadManuscriptSecD: {
      name: "uploadManuscriptSecD",
      label: "Please upload your manuscript *",
      requiredErrorMsg: "Manuscript is required",
      file: {}
    },
    documentsShowingsSubmissionSecD: {
      name: "documentsShowingsSubmissionSecD",
      label:
        "Please attach evidence or relevant documents showing the submission: *",
      requiredErrorMsg: "Attach evidence is required",
      file: {}
    },
    publicationAcceptedEvidenceSecD: {
      name: "publicationAcceptedEvidenceSecD",
      label: "Please upload your research publication or accepted evidence: *",
      requiredErrorMsg: "Attach evidence is required",
      file: {}
    },
    attachEvidenceTier1PaperSecD: {
      name: "attachEvidenceTier1PaperSecD",
      label: "Please attach an evidence of Tier1 paper *",
      requiredErrorMsg: "Attach evidence is required",
      file: {}
    },
    attachEvidenceUniversityInstituteRankingSecD: {
      name: "attachEvidenceUniversityInstituteRankingSecD",
      label:
        "Please attach the evidence of the Co-researcher's University/Institute ranking *",
      requiredErrorMsg: "Attach evidence is required",
      file: {}
    },
    additionalInformNoteSecD: {
      name: "additionalInformNoteSecD",
      label: "Additional inform/Note",
      requiredErrorMsg: "Additional inform/Note is required"
    },
    additionalDocumentSecD: {
      name: "additionalDocumentSecD",
      label: "Additional document",
      requiredErrorMsg: "Additional document is required",
      file: {}
    }
    //secDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD
  }
};
